import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { ApplyPipeModule } from '../../../pipes/apply.pipe';
import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'pictured-country-select-box',
  templateUrl: './pictured-country-select-box.component.html',
  styleUrl: './pictured-country-select-box.component.scss'
})
export class PicturedCountrySelectBoxComponent {
  @Input() value!: Record<string, unknown>;

  @Input() label = '';

  @Input() items: Record<string, unknown>[] = [];

  @Output() valueChange = new EventEmitter<string>();

  constructor(){
    
  }

  ngOnInit() : void {

  }

}
@NgModule({
  imports: [
    ApplyPipeModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    CommonModule],
  declarations: [PicturedCountrySelectBoxComponent],
  exports: [PicturedCountrySelectBoxComponent],
})
export class PicturedCountrySelectBoxModule {}